const lodashIsArray = require('lodash/isArray');
const lodashGet = require('lodash/get');

/**
 * Keep calling getter until it returns true or the timeout (ms) expires.
 * Callback is called with Error or the returned truthy value.
 * @param getter
 * @param timeout
 * @param callback
 */
export function waitUntilTruthy(getter, timeout, callback) {
	let interval = setInterval(tryComplete, 100);
	let startedAt = new Date();

	function tryComplete() {
		let result = getter();
		if (result) {
			clearInterval(interval);
			return callback(null, result);
		}

		if (new Date() - startedAt > timeout) {
			clearInterval(interval);
			return callback(new Error('Wait timeout'));
		}
	}
}

/**
 * Returns list of propery paths missing from ob or null, if nothing is missing
 * @param ob Object to test
 * @param paths Array of string paths. Deep paths (a.b) are supported
 * @param ignoreNulls If this is true, null will not be treated as missing property
 * @return {*}
 */
export function findMissingProperties(ob, paths, ignoreNulls = false) {
	if (!lodashIsArray(paths)) {
		paths = Array.prototype.slice.call(arguments, 1);
	}

	ob = ob || {};

	const pathsLength = paths.length;
	const results = [];
	for (let i = 0; i < pathsLength; i++) {
		let path = paths[i];
		const val = lodashGet(ob, path);
		if (val === undefined || (!ignoreNulls && val === null)) {
			results.push(path);
		}
	}

	return results.length ? results : null;
}

/**
 * Throws an error if some of the dependencies weren't provided
 */
export function assertDependencies(sender, expected, provided) {
	const keys = [];
	for (let key in expected) {
		if (expected.hasOwnProperty(key) && expected[key] === true) {
			// If a mandatory dependency
			keys.push(key);
		}
	}
	const missing = findMissingProperties(provided, keys);
	if (missing) {
		throw new Error(`${sender} is missing the following required dependencies: ${missing.join(', ')}`);
	}
}

/**
 * @param str
 * @param length
 */
export function padRight(str, length) {
	if (str.length >= length) {
		return str;
	}
	//noinspection JSPotentiallyInvalidConstructorUsage
	return str + Array(length - str.length).join(' ');
}

/**
 * Node-style inherits functionality
 * @param Ctor Target class
 * @param SuperCtor Parent class
 */
export function inherits(Ctor, SuperCtor) {
	Ctor.super_ = SuperCtor;
	Ctor.prototype = Object.create(SuperCtor.prototype, {
		constructor: {
			value: Ctor,
			enumerable: false,
			writable: true,
			configurable: true
		}
	});
}

/**
 * Constrains angle in range [-180..180]
 * @param angle Angle in degrees
 */
export function constrainAngle360(angle) {
	angle = (angle + 180) % 360;
	if (angle < 0) {
		angle += 360;
	}
	return angle - 180;
}

export function isInsideIFrame(window, ref = 'top') {
	try {
		return window.self !== window[ref];
	} catch (e) {
		return true;
	}
}
